export default "__VITE_ASSET__CghyIU63__"